import React from "react"

/**
 * Listening wallpaper — quiet sea/sky field with slow glow.
 */
export default function ListeningScene({ layerRef }) {
  return (
    <div
      ref={layerRef}
      className="listening-wallpaper fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="listening-cosmo-base" />
      <div className="listening-cosmo-glow listening-cosmo-glow--a" />
      <div className="listening-cosmo-glow listening-cosmo-glow--b" />
      <div className="listening-cosmo-specks" />
    </div>
  )
}
